const routes = [
  {
    path: '/student/medicalplan/:id?',
    name: 'medicalPlan',
    component: () => import('@/views/student/medical-plan/Main.vue'),
  },
];

export default routes;
